<template>
    <div id="styleSwitcher" class="style-switcher">

        <!--<a id="styleSwitcherOpen" class="style-switcher-open" href="#">
            <i class="fas fa-paint-brush"></i>
        </a>-->

        <form class="style-switcher-wrap" autocomplete="off">
            <!-- <h3>Estilos y Temas <a class="style-switcher-open close-config" href="#">+</a></h3> -->
            <h3>Estilos y Temas <a class="close-config" href="#">+</a></h3>
            
            <div v-if="visual == null">
                <h5 class="">No posee ajustes actualmente</h5>
                <a href="" class="text-warning" v-if="typeUser != 'integrator'">cargar ajustes por defecto</a>
                <br>
            </div>
            <div v-if="typeUser != 'integrator'" class="pt-3">
                <div>
                    <a v-if="visuals.bg == 'white'"
                        href="/configurations/change-mode"
                        class="notification-icon btn btn-dark btn-sm btn-block"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Modo noche"
                        style="text-decoration: none;">
                        <i class="fas fa-moon"></i> Modo oscuro
                    </a>
                    <a v-if="visuals.bg == 'dark'"
                        href="/configurations/change-mode"
                        class="notification-icon btn btn-light btn-sm btn-block"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Modo día"
                        style="text-decoration: none;">
                        <i class="fas fa-sun"></i> Modo Claro
                    </a>
                </div>


                <div class="pt-3">
                    <h5>Color de fondo del sidebar</h5>
                    <div class="form-group el-custom-control">
                        <button :class="{ 'active': visuals.sidebar_theme === 'white' }" type="button" @click="onChangeBgSidebar('white')" class="btn flex-fill" style="background-color: #ffffff;"></button>
                        <button :class="{ 'active': visuals.sidebar_theme === 'blue' }" type="button" @click="onChangeBgSidebar('blue')" class="btn flex-fill" style="background-color: #7367f0;"></button>
                        <!-- <button :class="{ 'active': visuals.sidebar_theme === 'gray' }" type="button" @click="onChangeBgSidebar('gray')" class="btn" style="background-color: #82868b;"></button> -->
                        <button :class="{ 'active': visuals.sidebar_theme === 'green' }" type="button" @click="onChangeBgSidebar('green')" class="btn flex-fill" style="background-color: #28c76f;"></button>
                        <button :class="{ 'active': visuals.sidebar_theme === 'red' }" type="button" @click="onChangeBgSidebar('red')" class="btn flex-fill" style="background-color: #ea5455;"></button>
                        <!-- <button :class="{ 'active': visuals.sidebar_theme === 'warning' }" type="button" @click="onChangeBgSidebar('warning')" class="btn" style="background-color: #ff9f43;"></button> -->
                        <!-- <button :class="{ 'active': visuals.sidebar_theme === 'ligth-blue' }" type="button" @click="onChangeBgSidebar('ligth-blue')" class="btn" style="background-color: #00cfe8;"></button> -->
                        <button :class="{ 'active': visuals.sidebar_theme === 'dark' }" type="button" @click="onChangeBgSidebar('dark')" class="btn flex-fill" style="background-color: #283046;"></button>
                    </div>
                </div>

                <div class="pt-3">
                    <h5>Menú lateral contraído</h5>
                    <div :class="{'has-danger': errors.compact_sidebar}">
                        <el-switch
                            v-model="form.compact_sidebar"
                            active-text="Si"
                            inactive-text="No"
                            @change="submitForm">
                        </el-switch>
                        <br>
                        <small class="form-control-feedback" v-if="errors.compact_sidebar" v-text="errors.compact_sidebar[0]"></small>
                    </div>
                </div>

                <div class="pt-3">
                    <h5>Cantidad de columnas en POS</h5>
                    <div :class="{'has-danger': errors.amount_plastic_bag_taxes}">
                        <el-select v-model="form.colums_grid_item" @change="submitForm">
                            <el-option label="3" value="3"></el-option>
                            <el-option label="4" value="4"></el-option>
                            <el-option label="5" value="5"></el-option>
                            <el-option label="6" value="6"></el-option>
                        </el-select>
                        <small class="form-control-feedback" v-if="errors.amount_plastic_bag_taxes" v-text="errors.amount_plastic_bag_taxes[0]"></small>
                    </div>
                </div>

                <div class="pt-3">
                    <h5>Cambiar tema</h5>
                    <div :class="{'has-danger': errors.compact_sidebar}">
                        <el-select
                            v-model="form.skin_id"
                            placeholder="Tema"
                            @change="submitForm"
                            class="pb-3">
                            <el-option
                                v-for="item in skins"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                        <small class="form-control-feedback" v-if="errors.compact_sidebar" v-text="errors.compact_sidebar[0]"></small>
                        <el-button type="button" @click="dialogSkins()" color="primary">Subir tema</el-button>
                    </div>
                </div>

            </div>

            <div class="pt-3">
                <div class="row">
                    <div class="col-12">
                        Tipo de Menu
                    </div>
                    <div class="col-6 wrapper_type_menu_item">
                        <button
                            type="button"
                            name="type_menu"
                            value="basic"
                            class="btn_type_menu"
                            :class="[type_menu == 'basic' ? '' : 'active_type_menu']"
                            @click="changeTypeMenu('basic')"
                        >
                            <img src="/images/menu_basico.png" alt="basic"
                                style="width: 50px; height: 50px; object-fit: cover;"
                            >
                            <h6>Básico</h6>
                            
                        </button>
                    </div>
                    <div class="col-6 wrapper_type_menu_item">
                        <button
                            type="button"
                            name="type_menu"
                            value="advanced"
                            class="btn_type_menu"
                            :class="[type_menu == 'advanced' ? '' : 'active_type_menu']"
                            @click="changeTypeMenu('advanced')"
                        >
                            <img src="/images/menu_avanzado.png" alt="advanced"
                                style="width: 50px; height: 50px; object-fit: cover;"
                            >
                            <h6>Avanzado</h6>
                        </button>
                    </div>
                </div>
            </div>
        </form>
        <dialog-skins :showDialog.sync="dialogSkinsVisible" :skins.sync="skins"/>
    </div>
</template>

<script>
    import DialogSkins from './partials/dialog_skins.vue'
    export default {
        props:['visual','typeUser'],
        components: {
            DialogSkins
        },
        data() {
            return {
                loading_submit: false,
                resource: 'configurations',
                errors: {},
                form: {},
                visuals: {},
                skins: {},
                dialogSkinsVisible: false,
                type_menu: 'basic'
            }
        },
        async created() {
            await this.initForm()
            await this.getRecords()
        },
        methods: {
            onChangeBgSidebar(theme) {
                this.visuals.sidebar_theme = theme;
                this.submit();
            },
            initForm() {
                this.errors = {}
                this.form = {
                    id: 1,
                    compact_sidebar: true,
                    colums_grid_item: 4,
                    enable_whatsapp: true,
                    phone_whatsapp: '',
                    skins: 1,
                }
            },
            getRecords() {
                this.$http.get(`/${this.resource}/record`) .then(response => {
                    if (response.data !== ''){
                        this.visuals = response.data.data.visual;
                        this.form = response.data.data;
                        this.skins = response.data.data.skins;
                        this.type_menu = response.data.data.type_menu
                    }
                });
            },
            submit() {
                this.visuals.navbar = 'fixed';
                this.$http.post(`/${this.resource}/visual_settings`, this.visuals).then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message);
                    }
                    else {
                        this.$message.error(response.data.message);
                    }
                }).catch(error => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                    }
                    else {
                        console.log(error);
                    }
                }).then(() => {
                    location.reload();
                });
            },
            submitForm() {
                this.loading_submit = true;
                this.$http.post(`/${this.resource}`, this.form).then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message);
                        location.reload()
                    }
                    else {
                        this.$message.error(response.data.message);
                    }
                }).catch(error => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                    }
                    else {
                        console.log(error);
                    }
                }).then(() => {
                    this.loading_submit = false;
                });
            },
            dialogSkins() {
                this.dialogSkinsVisible = true
            },

            async changeTypeMenu(type) {
                this.loading_submit = true;
                this.$http.post(`/${this.resource}/update-type-menu`, {
                    type_menu: type
                }).then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message);
                        location.reload()
                    }
                    else {
                        this.$message.error(response.data.message);
                    }
                }).catch(error => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                    }
                    else {
                        console.log(error);
                    }
                }).then(() => {
                    this.loading_submit = false;
                })
            }
        }
    }
</script>
<style scoped lang=scss>
.el-custom-control{
    display: flex;
    align-content: center;
    .btn{
        margin-right: .5rem;
        $size: 20px;
        width: $size;
        height: $size;
        border-radius: 4px;
        padding: 0;
        &.active{
            box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, .5);
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/views/tenant/configurations/visual.vue